// extracted by mini-css-extract-plugin
export var actionButton = "_7l-1";
export var actionButtons = "_7l-2";
export var actions = "_7l-0";
export var aiUnread = "_7l-10";
export var alignCenter = "_7l-h";
export var backWrapper = "_7l-3";
export var cellContainer = "_7l-4";
export var checkboxContainer = "_7l-5";
export var contentContainer = "_7l-6";
export var contentHeader = "_7l-8";
export var conversationsTableWrapper = "_7l-s";
export var draftReplyBadgeContainer = "_7l-m";
export var dropdownItem = "_7l-b";
export var dropdownItemsContainer = "_7l-a";
export var dropdownTitle = "_7l-c";
export var errorIcon = "_7l-7";
export var filter = "_7l-d";
export var gray = "_7l-i";
export var headerActionButtons = "_7l-e";
export var headerCheckboxContainer = "_7l-f";
export var icon = "_7l-j";
export var menuContainer = "_7l-k";
export var noMoreTicketsIcon = "_7l-12";
export var noMoreTicketsSubText = "_7l-13";
export var oneLine = "_7l-l";
export var optionsButton = "_7l-n";
export var plus = "_7l-o";
export var portalButtonsWrapper = "_7l-g";
export var red = "_7l-p";
export var scrolledTop = "_7l-9";
export var search = "_7l-q";
export var selectedConversationsCount = "_7l-r";
export var spinner = "_7l-t";
export var strong = "_7l-u";
export var summaryCell = "_7l-v";
export var tableContainer = "_7l-11";
export var tagContainer = "_7l-w";
export var threeDots = "_7l-x";
export var twoLines = "_7l-y";
export var unread = "_7l-z";